<template>
  <div>
    <div class="toolbar iphoneX-bttom">
      <div class="t_item" @click="go('/mainLiao')">
        <img :src="activeKey === 'mainLiao' ? icons.info.active : icons.info.inactive">
        <div :class="{ active: activeKey === 'mainLiao' }">我的料</div>
      </div>
      <div class="t_item" @click="go('/fabrication')">
        <img :src="activeKey === 'fabrication' ? icons.plus.active : icons.plus.inactive">
        <div :class="{ active: activeKey === 'fabrication' }">制作料</div>
      </div>
      <div class="t_item" @click="go('/center')">
        <img :src="activeKey === 'center' ? icons.my.active : icons.my.inactive">
        <div :class="{ active: activeKey === 'center' }">我的</div>
      </div>
    </div>
    <div class="iphoneX-bttom"></div>
    <div style="height: 4rem;"></div>
  </div>
</template>

<script>
export default {
  name: 'BottomTabBar',
  props: {
    active: {
      type: String,
      default: ''
    }
  },
  computed: {
    activeKey () {
      if (this.active) return this.active
      const p = (this.$route && this.$route.path) || ''
      if (p.indexOf('/fabrication') === 0) return 'fabrication'
      if (p.indexOf('/center') === 0) return 'center'
      return 'mainLiao'
    },
    icons () {
      return {
        info: {
          active: 'http://oss.xuekastart.cn/jinriyouliao/tabbar/info_active%402x.png',
          inactive: 'http://oss.xuekastart.cn/jinriyouliao/tabbar/info%402x.png'
        },
        plus: {
          active: 'http://oss.xuekastart.cn/jinriyouliao/tabbar/plus_active%402x.png',
          inactive: 'http://oss.xuekastart.cn/jinriyouliao/tabbar/plus%402x.png'
        },
        my: {
          active: 'http://oss.xuekastart.cn/jinriyouliao/tabbar/my_active%402x.png',
          inactive: 'http://oss.xuekastart.cn/jinriyouliao/tabbar/my%402x.png'
        }
      }
    }
  },
  methods: {
    go (path) {
      if (!this.$router) return
      const cur = (this.$route && this.$route.path) || ''
      if (cur === path) return
      this.$router.push(path).catch(() => {})
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/common/BottomTabBar.vue